import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import ProductVariationList from './fetchProductVariation/ProductVariationList';
import AddVariationPopup from './addProductVariation/AddVariation';
import { toast } from 'react-toastify';
import {
  fetchVariations,
  addVariation,
  updateVariation,
  deleteVariation,
} from '../../../../Reducer/productVariationSlice';

const ProductVariation = ({ product }) => {
  const { id } = useParams();
  const dispatch = useDispatch();

  const { variations, loading, error } = useSelector(
    (state) => state.productVariations
  );

  const [showPopup, setShowPopup] = useState(false);
  const [editingVariation, setEditingVariation] = useState(null);
console.log("Product product from product variation: ", product);
  useEffect(() => {
    if (product) {
      dispatch(fetchVariations(product));
    }
  }, [product, dispatch]);

  const handleAddVariationClick = () => setShowPopup(true);
  const handlePopupClose = () => {
    setShowPopup(false);
    setEditingVariation(null);
  };

  const handleAddVariation = async (newVariation) => {
    try {
      await dispatch(addVariation(newVariation)).unwrap();
      toast.success('Variant added successfully');
      dispatch(fetchVariations(product));
    } catch (err) {
      toast.error(err || 'Failed to add variation');
    } finally {
      setShowPopup(false);
    }
  };

  const handleEditVariation = (variation) => {
    setEditingVariation(variation);
    setShowPopup(true);
  };

  const handleUpdateVariation = async (updatedVariation) => {
    try {
      await dispatch(
        updateVariation({
          product_variant_id: editingVariation.product_variant_id,
          updatedVariation,
        })
      ).unwrap();
      toast.success('Variant updated successfully');
      dispatch(fetchVariations(product));
    } catch (err) {
      toast.error(err || 'Failed to update variation');
    } finally {
      setShowPopup(false);
      setEditingVariation(null);
    }
  };

  const handleDeleteVariation = async (product_variant_id) => {
    try {
      await dispatch(deleteVariation({ product_variant_id })).unwrap();
      toast.success('Variant deleted successfully');
      dispatch(fetchVariations(product));
    } catch (err) {
      toast.error(err || 'Failed to delete variation');
    }
  };

  if (loading) return <div>Loading variations...</div>;

  return (
    <div>
      <button
        onClick={handleAddVariationClick}
        style={{
          marginBottom: '16px',
          padding: '10px 20px',
          backgroundColor: 'rgb(90 92 125 / 87%)',
          color: '#fff',
          border: 'none',
          borderRadius: '4px',
          cursor: 'pointer',
          fontSize: '16px',
        }}
      >
        Add Variation
      </button>

      {error ? (
        <div style={{ color: 'red' }}>Error: {error}</div>
      ) : (
        <ProductVariationList
          variations={variations}
          onEditVariation={handleEditVariation}
          onDeleteVariation={handleDeleteVariation}
        />
      )}

      {showPopup && (
        <AddVariationPopup
          onClose={handlePopupClose}
          onAdd={editingVariation ? handleUpdateVariation : handleAddVariation}
          editingVariation={editingVariation}
          product_id={product}
        />
      )}
    </div>
  );
};

export default ProductVariation;
